import styled from 'styled-components';
import { Form } from '@unform/web';

export const Conteiner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  margin: 1rem;
`;

export const Formulario = styled(Form)`
  display: flex;
  flex-direction: column;

  width: 95%;
  margin: 1rem;
  gap: 10px;

  button {
    width: fit-content;
    align-self: end;
  }
`;

export const LinhaModal = styled.p`
  width: 95%;
  margin-bottom: 10px;

  #destaqueModal {
    font-weight: 700;
  }
`;
